import { defineMessages } from 'react-intl';

export default defineMessages({
  learnMoreLink: {
    id: 'frontbucket.branches.learnMoreLink',
    description: 'A link to more information about creating branches.',
    defaultMessage: 'Learn more',
  },
  description: {
    id: 'frontbucket.branches.emptyStateDescription',
    description: 'Descriptive text on branches empty state screen',
    defaultMessage:
      "It's a good idea to create a separate branch for each new feature.",
  },
  header: {
    id: 'frontbucket.branches.overview.emptyStateHeader',
    description: 'Header of branches empty state screen',
    defaultMessage: 'Time to branch out',
  },
});
